import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';
import { useIsLaptop } from '#src/hooks/device/useIsLaptop.ts';

export const useShowBottomBarNav = () => {
  const { currentUser } = useCurrentUserContext();
  const isTabletAndAbove = useIsLaptop();
  return !isTabletAndAbove && !!currentUser;
};
